module.exports = __webpack_public_path__ + "img/userAppointRes_a.b6e6689b.png";